import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { Secondary } from "../Secondary/Secondary.mjs";
import { Strong } from "../Strong/Strong.mjs";
import { Text } from "../Text/Text.mjs";
import { Stack } from "../Stack/Stack.mjs";
const FieldLabel = ({
  id,
  htmlFor,
  label,
  disabled,
  secondaryLabel,
  tertiaryLabel,
  description,
  descriptionId,
  data
}) => {
  if (!label && !description) {
    return null;
  }
  const labelEl = /* @__PURE__ */ jsxs(Text, { tone: disabled ? "secondary" : void 0, children: [
    /* @__PURE__ */ jsx(Strong, { children: label }),
    secondaryLabel ? /* @__PURE__ */ jsxs(Secondary, { children: [
      " (",
      secondaryLabel,
      ")"
    ] }) : null
  ] });
  return /* @__PURE__ */ jsxs(Stack, { space: "small", align: "left", data, children: [
    label ? /* @__PURE__ */ jsxs(Box, { component: "span", display: "flex", justifyContent: "spaceBetween", children: [
      htmlFor === false ? labelEl : /* @__PURE__ */ jsx("label", { id, htmlFor, children: labelEl }),
      tertiaryLabel ? /* @__PURE__ */ jsxs(Text, { children: [
        " ",
        tertiaryLabel
      ] }) : null
    ] }) : null,
    description ? /* @__PURE__ */ jsx(Text, { tone: "secondary", id: descriptionId, children: description }) : null
  ] });
};
export {
  FieldLabel
};
